import axios from "axios";

// Same origin when nothing is baked in. Without the fallback an unset
// REACT_APP_BACKEND_URL builds the literal string "undefined/api", and because
// the server answers unknown paths with index.html that URL returns 200 with a
// page of HTML in it - so every call "succeeds", every component is handed a
// string where it expected its data, and the app dies somewhere far away with
// "cannot read properties of undefined". Failing to a working default beats
// failing into a mystery.
const BASE = process.env.REACT_APP_BACKEND_URL || "";
const TOKEN_KEY = "crm-token";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

// Bearer-token auth (works same-origin in preview AND cross-origin when deployed,
// where wildcard CORS + cookies would otherwise be blocked by the browser).
const api = axios.create({
  baseURL: `${BASE}/api`,
});

api.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
